import { AmountCell, PercentageCell } from '@/components'
import type { ColumnDef } from '@/components/ui/table/types'
import type { IncomeTableRow } from './types'

const incomeSourceColumns: ColumnDef<IncomeTableRow, unknown>[] = [
  {
    accessorKey: 'incomeFromOutside',
    header: 'From outside',
    size: 150,
    cell: AmountCell,
  },
  {
    accessorKey: 'incomeBetweenProjectAccounts',
    header: 'Between project accounts',
    size: 220,
    cell: AmountCell,
  },
]

export function incomeColumns(
  showIncomeSources: boolean,
): ColumnDef<IncomeTableRow, unknown>[] {
  return [
    {
      accessorKey: 'month',
      header: 'Month',
      size: 150,
      meta: { isFluid: true },
    },
    {
      accessorKey: 'income',
      header: 'Income',
      size: 150,
      cell: AmountCell,
    },
    ...(showIncomeSources ? incomeSourceColumns : []),
    {
      accessorKey: 'change',
      header: 'Change',
      size: 150,
      cell: PercentageCell,
    },
  ]
}
